import { StartdateComponent } from './../../../signup/startdate/startdate.component';
export class FanStatusSummary {
    noOfFans: number;
    Status: String;
}

export class ProfileStatus {
    ctnNumber: any;
    userName: String;
    model: String;
    status: String;
}

export class SessionProfileStatus {
    setNo: number;
    sessionCtns: Array<ProfileStatus>;

    constructor(setNo, sessionCtns){
        this.setNo = setNo;
        this.sessionCtns = sessionCtns;
    }
}

export class FanSummary {
    fanSummary: Array<FanStatusSummary>;
}

export class AppleCertificate {
    hasValidAppleCertificate: boolean;
}

export class Fan {
    fanId: number;
    status: String;
    participationDate: Date;
}

export class Profile {
    profileId: number;
    profileName: string;
}

export class DeviceStatusSummary {
    noOfDevices: number;
    Status: String;
}

export class DevicesSummary {
    fan: Fan;
    profile: Profile;
    deviceStatusSummary: Array<DeviceStatusSummary>;

    constructor() {
        this.deviceStatusSummary = [];
    }
}

export class FansDeviceSummary {
    totalRecords: number;
    currentPage: number;
    recordsPerPage: number;
    devicesSummary: Array<DevicesSummary>;
    constructor() {
        this.devicesSummary = [];
    }
}

export class CTNDetails {
    ctn: String;
    fan: number;
    profileId: String;
    ban: number;
    userName: String;
    groupName:String;
    ratePlan: String;
    userId: String;
    emailId: String;
    deviceInfo: DeviceInformation;
    ctnStatus: CTNStatus;
}

export class DeviceInformation {
    deviceName: String;
    platform: String;
    os: String;
    imei: String;
    complianceStatus: String;
    checkInDate: String;
    emmDeviceId: any;
    emmTenantId: any;
    emmProvider: any;
    deviceId:String;
}

export class CTNStatus {
    enrollmentStatus: any;
    complianceStatus: String;
    mobilityStatus: String;
    applicationStatus: Array<String>;
    programStatus: String;
}

export class MDMDetails {
    productCode: string;
    ibmEmmAccountId: string;
    googleEmmAccountId: string;
    samsungEmmAccountId: string;
    latestAccountType: string;
    appleEmmAccountId: string;

    constructor() {
        this.productCode = undefined;
        this.ibmEmmAccountId = undefined;
        this.googleEmmAccountId = undefined;
        this.samsungEmmAccountId = undefined;
        this.latestAccountType = undefined;
        this.appleEmmAccountId = undefined;
    }
}
